export const RUN_STATUS = {
	OK: 'OK',
	FAIL: 'FAIL',
	RUNNING: 'RUNNING',
	PENDING: 'PENDING',
	CANCELED: 'CANCELED',
	SKIPPED: 'SKIPPED'
};

export const RUN_ACTION = {
	RUN: 'RUN',
	SKIP: 'SKIP'
};

export const STATUS_CLASSES = {
	OK: 'text-success',
	FAIL: 'text-danger',
	RUNNING: 'text-warning',
	SKIPPED: 'text-muted',
	CANCELED: 'text-muted'
};

export const EXECUTION_STRATEGY = {
	FAIL_ON_FIRST: 'FAIL_ON_FIRST',
	EXECUTE_ALL: 'EXECUTE_ALL'
};

export const SUCCESS_STATUS = 200;
